
import { defineComponent } from "vue";
import api, { Company, CompanyProducer } from "../../api/backend-api";
import { AxiosError } from "axios";
import ErrorBlock from "@/components/ErrorBlock.vue";

interface State {
  msg: string;
  company: Company;
  errors: AxiosError[];
  producerAuth: producerAuthStruct[];
}

interface producerAuthStruct {
  type: string;
  user: string;
  pass: string;
  token: string;
}

export default defineComponent({
  name: "ReceiverCompanyForm",
  components: { ErrorBlock },
  mounted() {
    this.$nextTick(() => {
      this.callGetCompany();
    });
  },
  data: (): State => {
    let company = { } as Company;
    return {
      msg: "Company details",
      company: company,
      producerAuth: [],
      errors: [],
    };
  },
  methods: {
    addProducer(provider: string) {
      const producer = {
        Name: provider,
        Token: '',
        Enabled: true,
      } as CompanyProducer
      if (!this.company.Producers) {
        this.company.Producers = [];
      }
      this.company.Producers.push(producer)

      const producerAuth = {
        type: '',
        user: '',
        pass: '',
        token: '',
      } as producerAuthStruct
      if (!this.producerAuth) {
        this.producerAuth = [];
      }
      this.producerAuth.push(producerAuth)

    },
    refreshProducerToken(idx: number) {
      api
        .generateProducerToken()
        .then((response) => {
          if (!this.company.Producers) {
            return
          }
          this.producerAuth[idx].token = response.data.Token
        })
        .catch((error: AxiosError) => {
          this.errors.push(error.response?.data.message);
        })
    },
    callSave() {
      this.errors = [];
      const saveButton = document.getElementById('save')
      if (saveButton) {
        saveButton.classList.toggle('disabled')
        saveButton.textContent = '...'
      }
      
      if (this.company.Producers) {
        for (const [idx, value] of this.producerAuth.entries()) {
          if (value.type == 'user') {
            this.company.Producers[idx].Token = value.user + ':' + value.pass
          } else {
            this.company.Producers[idx].Token = value.token
          }
        }
      }

      api
        .saveReceiverCompany(this.company)
        .then(() => {
          this.$router.go(0)
        })
        .catch((error: AxiosError) => {
          this.errors.push(error.response?.data.message);
          if (saveButton) {
            saveButton.classList.toggle('disabled')
            saveButton.textContent = 'save'
          }
        });
    },
    callGetCompany() {

      this.errors = [];
      let company_id = '';
      if (typeof this.$route.params.slug != 'string') {
        throw new Error("Invalid url");
      }
      company_id = this.$route.params.slug

      api
        .getReceiverCompany(company_id)
        .then((response) => {
          this.company = response.data;
          if (this.company.Producers) {
            for (const [idx, value] of this.company.Producers.entries()) {
              console.log(value)
              let authStruct = { } as producerAuthStruct
              if (value.Token.indexOf(':') != -1) {
                authStruct.type = 'user';
                [authStruct.user, authStruct.pass] = value.Token.split(':')
              } else {
                authStruct.type = 'token';
                authStruct.token = value.Token;
              }

              this.producerAuth[idx] = authStruct
            }
          }
        })
        .catch((error: AxiosError) => {
          this.errors.push(error.response?.data.message);
        });
    },
  }
});
